import { createElement, FC, useContext, useEffect } from 'react';

import Component from '../component/compound/MenuDrawer';
import { MENU_ITEMS } from '../component/compound/MenuDrawer';
import { context as configContext } from '../context/config';
import { context as DependencyContext } from '../context/dependency';
import { context as HistoryContext } from '../context/history';
import { context as StateContext } from '../context/state';

type Props = {
  className?: string;
};

const MenuDrawer: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);
  const history = useContext(HistoryContext);
  const dependency = useContext(DependencyContext);
  const config = useContext(configContext);
  // const [currentAgent, setCurrentAgent] = useState();
  const path = history.location.pathname.slice(1);
  const selected = Object.keys(MENU_ITEMS).includes(path) ? path : '/home';
  const open = state.drawerOpen;
  const profileUrl = state.authentication.signedInUser
    ? `${config.PROFILE_WEB_URL}/users/${state.authentication.signedInUser.id}`
    : `${config.PROFILE_WEB_URL}`;
  const user = state.authentication.signedInUser!;
  const mfaSetupRequired =
    !!state.authentication.signedInUser &&
    !!state.authentication.signedInUser.mfaRequired &&
    !state.authentication.signedInUser.otpEnabled;
  const organizations = state.organization.organizations;
  const currentOrgOrAccount = state.currentOrgOrAccount;
  const memberships = state.organization.memberships.memberships;

  const currentAccount = currentOrgOrAccount && currentOrgOrAccount.isAccount() ? currentOrgOrAccount : null;
  const currentOrganization = currentOrgOrAccount;
  const currentAcctAccount = state.currentAcctAccount;
  const currentAcctAccountLoading = state.currentAcctAccountLoading;
  const currentBfOrganization = state.currentBfOrganization;
  const currentBfOrganizationLoading = state.currentBfOrganizationLoading;
  const currentAgent = state.currentAgent;

  useEffect(() => {
    if (currentAccount && !currentAcctAccount) {
      dependency.accountUsecase.getAccount(currentAccount.id);
      dependency.acctUsecase.getAccount(currentAccount.id);
    }
    if (currentOrganization && !currentBfOrganization) {
      dependency.bfUsecase.getOrganization(currentOrganization.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrganization]);

  useEffect(() => {
    if (!user || mfaSetupRequired) {
      return;
    }
    dependency.agentUsecase.currentAgent();
  }, [dependency.agentUsecase, user, mfaSetupRequired]);

  if (path.indexOf('invitation_agent') !== -1) {
    return null;
  }
  return !mfaSetupRequired &&
    !state.fatalError &&
    !state.authentication.done &&
    state.authentication.fetching === 0 &&
    user ? (
    <Component
      selected={selected}
      onSelectMenu={item => {
        history.push(`/${item}`);
      }}
      open={open}
      profileUrl={profileUrl}
      organizations={organizations}
      onClose={() => dependency.drawerOpenUsecase.setOpen(false)}
      className={className}
      setCurrentOrgOrAccount={dependency.organizationUsecase.setCurrentOrgOrAccount}
      currentOrgOrAccount={currentOrgOrAccount}
      currentAccount={currentAccount}
      currentOrganization={currentOrganization}
      currentAcctAccount={currentAcctAccount}
      currentAcctAccountLoading={currentAcctAccountLoading}
      currentBfOrganization={currentBfOrganization}
      currentBfOrganizationLoading={currentBfOrganizationLoading}
      location={history.location}
      currentUserId={state.authentication.signedInUser!.id}
      memberships={memberships || undefined}
      currentAgent={currentAgent}
    />
  ) : null;
};

export default MenuDrawer;
